module.exports = __webpack_public_path__ + "static/media/activity.0e6a7a81.svg";